export const projectTrainee = [
    {
        id:"proj_001",
        name:"Ms. Safamariyam. E",
        tenure: "May 2022 - Sept 2022",
        college:"MG University-Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_002",
        name:"Ms. Anju George",
        tenure:"Nov 2019 - Mar 2020",
        college:"Kannur University-Kerala",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_003",
        name:"Mr. Poornendu V. C",
        tenure:"Dec 2019 - April 2020",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_004",
        name:"Ms. Haripriya. K",
        college:"Cochin University of Scinece & Technology",
        tenure:"Dec 2018 - April 2019",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_005",
        name:"Ms. Anagha V. G",
        tenure:"Dec 2018 - April 2019",
        college:"Kannur University Kerala",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_006",
        name:"Ms. Anjana Pavithram",
        tenure:"Dec 2018 - April 2019",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_007",
        name:"Ms. Anju M. R",
        tenure:"Mar 2018 - May 2018",
        college:"Calicut University",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_008",
        name:"Ms. Milda. C. Philip",
        tenure:"Jan 2018 - June 2018",
        college:"MG University Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_009",
        name:"Ms. Anila K. A",
        tenure:"Jan 2018 - April 2018",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_010",
        name:"Mr. Vipin. M",
        tenure:"Jan 2018 - June 2018",
        college:"Kannur University Kerala",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_011",
        name:"Ms. Bonsy K. J",
        tenure:"May 2017 - July 2017",
        college:"MG University Kottayam",
        course:"Summer Project Trainee"
    },{
        id:"proj_012",
        name:"Ms. Irine Joy",
        tenure:"July 2016 - June 2017",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_013",
        name:"Ms. Isfana. K. K",
        tenure:"April 2017 - June 2017",
        college:"University of Calicut",
        course:"Summer Project Trainee"
    },{
        id:"proj_014",
        name:"Ms. Sheedurga B. M",
        tenure:"March 2017 - June 2017",
        college:"Calicut University",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_015",
        name:"Mr. Mridhul Ram K R",
        tenure:"May 2016 - July 2016",
        college:"IISER Kolkata",
        course:"Indian Academy of Sciences, Summer Research Fellow"
    },{
        id:"proj_016",
        name:"Mr. Cygnet. C. T",
        tenure:"Jan 2016 - June 2016",
        college:"MG University Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_017",
        name:"Mr. Shebin K.J",
        tenure:"Jan 2016 - June 2016",
        college:"MG University Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_018",
        name:"Ms. Sivaganga K.C",
        tenure:"Dec 2015 - April 2016",
        college:"MG University Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_019",
        name:"Ms. Joes Elizabeth Thomas",
        tenure:"July 2015 - June 2016",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_020",
        name:"Mr. Debajit Gogoi",
        tenure:"June 2015 - Aug 2015",
        college:"Guwahati University",
        course:"Indian Academy of Sciences, Summer Research Fellow"
    },{
        id:"proj_021",
        name:"Ms. Aswathy Rajagopal",
        tenure:"Mar 2015 - May 2015",
        college:"Calicut University",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_022",
        name:"Ms. Seethalakshmi K. R",
        tenure:"Feb 2017 - July 2017",
        college:"MG University Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_023",
        name:"Mr. Nideesh. P",
        tenure:"Dec 2016 - April 2017",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_024",
        name:"Mr. Prateek Soni",
        tenure:"June 2017 - Nov 2017",
        college:"Center for Excellence in Basic Sciences, Mumbai",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_025",
        name:"Ms. Neethu K. M",
        tenure:"July 2016 - June 2017",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_026",
        name:"Mr. Sahil Tapiawala",
        tenure:"May 2014 - July 2014",
        college:"BITS Goa",
        course:"M.Sc Chemistry Summer Project"
    },{
        id:"proj_027",
        name:"Ms. Aswathy",
        tenure:"March 2014 - May 2014",
        college:"Calicut University, Kerala",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_028",
        name:"Ms. Betsy KJ",
        tenure:"Dec 2013 - April 2014",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_029",
        name:"Ms. Remya Raju",
        tenure:"Jan 2014 - May 2014",
        college:"MG University, Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_030",
        name:"Ms. Shilpa Gopikumar",
        tenure:"July 2013 - June 2014",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_031",
        name:"Mr. Belvin Thomas",
        tenure:"May 2013 - July 2013",
        college:"IISER Trivandrum",
        course:"DST-INSPIRE Summer Project"
    },{
        id:"proj_032",
        name:"Ms. Chinchu Lizen Babu",
        tenure:"Jan 2013 - May 2013",
        college:"MG University, Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_033",
        name:"Mr. Ziyad K V",
        tenure:"July 2012 - May 2013",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_034",
        name:"Mr. Preet Mahalay",
        tenure:"May 2012 - July 2012",
        college:"NISER Bubaneswar",
        course:"DST-INSPIRE Summer Project"
    },{
        id:"proj_035",
        name:"Ms. Athira Krishnan",
        tenure:"Jan 2015 - May 2015",
        college:"Cochin University of Science & Technology",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_036",
        name:"Mr. Yadukiran V",
        tenure:"Jan 2015 - May 2015",
        college:"Kannur University, Kerala",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_037",
        name:"Mr. Arun Antony",
        tenure:"Jan 2015 - May 2015",
        college:"MG University, Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_038",
        name:"Ms. Vidhyalakshmi",
        tenure:"July 2014 - June 2015",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_039",
        name:"Ms. Shruti Maheshwari",
        tenure:"May 2014 - July 2014",
        college:"Indian Institute of Chemical Technology, Mumbai",
        course:"Indian Academy of Sciences, Summer Research Fellow"
    },{
        id:"proj_040",
        name:"Ms. Ashna T S",
        tenure:"Jan 2012 - May 2012",
        college:"MG University, Kottayam",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_041",
        name:"Mr. Sudheesh Kumar V",
        tenure:"July 2011 - June 2012",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_042",
        name:"Ms. Meera C J",
        tenure:"July 2011 - June 2012",
        college:"Cochin University of Science & Technology",
        course:"M.Tech Project Trainee"
    },{
        id:"proj_043",
        name:"Ms. Nisha Surendram Nair",
        tenure:"Mar 2012 - May 2012",
        college:"Calicut University",
        course:"M.Sc Project Trainee"
    },{
        id:"proj_044",
        name:"Ms. Anju V P",
        tenure:"April 2011 - May 2011",
        college:"Calicut University",
        course:"M.Sc Project Trainee"
    }
];